import React from "react";
var Divider = function (props) {
    return React.createElement("div", { className: "individual-divider " + props.className, style: { height: (props.height || (props.small ? '4.7rem' : '8.5rem')), width: '100%' } });
};
export default Divider;
//# sourceMappingURL=Divider.js.map